import { useEffect, useState } from "react";
import { Section, Eyebrow, H2, Lead, GlassCard } from "../components/site/Primitives";
import { GraduationCap, BadgeCheck, ArrowRight } from "lucide-react";
import api from "../lib/api";
import { log } from "../lib/logger";

export default function Education() {
  const [courses, setCourses] = useState([]);
  useEffect(() => { api.get("/courses").then((r) => setCourses(r.data.items)).catch((e) => log.warn("courses fetch failed", e?.message)); }, []);
  return (
    <div>
      <Section className="pt-40">
        <Eyebrow>220 Education & Certification</Eyebrow>
        <H2 className="max-w-4xl">Train. Certify. Place. Repeat.</H2>
        <Lead className="mt-6">
          A closed-loop pipeline that turns workforce demand inside the 220 ecosystem into real,
          certified jobs — with veteran priority across every program.
        </Lead>
      </Section>

      <Section className="pt-0">
        <Eyebrow>Programs</Eyebrow>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map((c) => (
            <GlassCard key={c.id} className="p-6 flex flex-col h-full">
              <GraduationCap className="text-gold mb-4" />
              <div className="font-display text-xl mb-2">{c.title}</div>
              <div className="text-xs text-white/40 uppercase tracking-[0.2em] mb-4">{c.format} · {c.duration_weeks} weeks</div>
              {c.veteran_priority && (
                <div className="inline-flex items-center gap-2 text-xs text-gold border border-gold/40 px-2 py-1 self-start mb-4">
                  <BadgeCheck size={12} /> Veteran Priority
                </div>
              )}
              <button className="btn-ghost mt-auto text-sm">Enroll Interest <ArrowRight size={14} /></button>
            </GlassCard>
          ))}
        </div>
      </Section>

      <Section className="border-t border-white/5">
        <Eyebrow>How It Works</Eyebrow>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-4 gap-6">
          {[
            { n: "01", t: "Apply", b: "No prior experience required for most tracks." },
            { n: "02", t: "Train", b: "Hybrid and on-site cohorts led by industry instructors." },
            { n: "03", t: "Certify", b: "OSHA, trade-specific, and degree-aligned credentials." },
            { n: "04", t: "Place", b: "Direct placement inside 220 subsidiaries or partner firms." },
          ].map((s) => (
            <GlassCard key={s.n} className="p-6">
              <div className="font-display text-3xl text-gold mb-2">{s.n}</div>
              <div className="font-display text-xl mb-2">{s.t}</div>
              <p className="text-sm text-white/65">{s.b}</p>
            </GlassCard>
          ))}
        </div>
      </Section>
    </div>
  );
}
